import React from 'react'
import { Section, Link } from 'newComponents'
import './styles.scss'

const SubprocessorTable = (props) => {
  const { data } = props
  const { items } = data

  return (
    <Section className="subprocessor-table">
      <table className="sub-table">
        <thead className="sub-table-head">
          <tr className="sub-table-row">
            <th className="sub-table-heading">Name of Subprocessor</th>
            <th className="sub-table-heading">Purpose</th>
            <th className="sub-table-heading">Entity Country</th>
          </tr>
        </thead>
        <tbody className="sub-table-body">
          {items.map((row) => {
            const { country, purpose, subprocessor_link: link, subprocessor_name: name } = row
            return (
              <tr className="sub-table-row" key={name?.text}>
                {name?.text && (
                  <td className="sub-table-cell">
                    <Link to={link?.url} className="sub-table-cell-link">
                      {name.text}
                    </Link>
                  </td>
                )}
                {purpose?.text && <td className="sub-table-cell">{purpose.text}</td>}
                {country?.text && <td className="sub-table-cell">{country.text}</td>}
              </tr>
            )
          })}
        </tbody>
      </table>
    </Section>
  )
}

export default SubprocessorTable
